import React,{useContext,useEffect, useState, useRef,useReducer, useMemo} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, DeleteIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, LoadPrioIcon} from "../../svg/svgIcons";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { Checkbox } from 'primereact/checkbox';
import { createAsyncNavigateHandlers } from '../../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../../utils/maintenanceNavigationContext';
import { useMaintenanceTemplates } from '../../../utils/useMaintenanceTemplates';
import { uiT as t } from '../../../utils/uiTranslate';

export default function MaintenanceTemplateAdd({maintenance_template, type, navigationContext}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { refetch } = useMaintenanceTemplates();
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,setDialogText,setVisible} = useContext(UtilContext);
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);

    const [formMaintenanceTemplate,setformMaintenanceTemplate] = useState(maintenance_template);
    const [formType, setFormType] = useState(type);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit maintenance"))?false:true);

    function addNewTrainingType(){
        dispatch({type:'create_new_tab',name: t('MaintenanceTemplateList.Tab.New'), translationKey: 'MaintenanceTemplateList.Tab.New', legacyLabel: t('MaintenanceTemplateList.Tab.New'),page:'MaintenanceTemplateAdd',props:{maintenance_template: null,type:'add'},mask:'mntn012'})
    }
    function copyTrainingType(){
        dispatch({type:'create_new_tab',name: t('MaintenanceTemplateList.Tab.New'), translationKey: 'MaintenanceTemplateList.Tab.New', legacyLabel: t('MaintenanceTemplateList.Tab.New'),page:'MaintenanceTemplateAdd',props:{maintenance_template: formik.values,type:'add'},mask:'mntn012'})
    }

    useEffect(() => {
        // Update the document title using the browser API
        if(formMaintenanceTemplate!=null){
            if(user.permissions?.includes("edit maintenance"))setScrollIcons(false);
        }
    },[formMaintenanceTemplate]);

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = '*Povinné';
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: formMaintenanceTemplate==null?{
            name:'',machine_type_id:'',description:'',copy_records:false
        }:formMaintenanceTemplate,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            if(values?.copy_records)formData.append("maintenance_template_id",maintenance_template.id);
            if(formType=="add"){
                postRequest('/api/maintenance_templates', formData,true)
                .then((response) => {
                    if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                    refetch();
                    getRequest("/api/maintenance_templates").then((r) => {
                        const list = r?.data ?? [];
                        if (list.length - 1 >= 0) formik.setValues(list[list.length - 1]);
                        setFormType("edit");
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    }).catch(() => {});
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('Common.OfflineQueued'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/maintenance_templates/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                    refetch();
                    formik.setValues(values);
                    setVisible(false);
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('Common.OfflineQueued'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const applyTemplate = (data) => {
            if (!data) return;
            setformMaintenanceTemplate(data);
            if (data.id != null) setFormType('edit');
        };
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.LoadingShort'));
            setVisible?.(true);
            try {
                const q = toParams();
                const url = `/api/maintenance_templates/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null) {
            const toParams = () => navigationContextToQueryParams(navigationContext);
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), applyTemplate, () => formik.values?.id ?? formMaintenanceTemplate?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), applyTemplate, () => formik.values?.id ?? formMaintenanceTemplate?.id);
    }, [navigationContext, formik.values?.id, formMaintenanceTemplate?.id, setDialogText, setVisible]);

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTrainingType()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyTrainingType()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('MaintenanceTemplateList.Tab.New'),"MaintenanceTemplateAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("MaintenanceTemplateAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.SABLONA_UKONOV')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                        <div>
                            <label
                                htmlFor="name"
                                className="block text-md font-semibold text-gray-800"
                            >{t('ServiceTaskPlanner.TemplateNameLabel')}</label>
                            <input 
                                name='name'
                                type="text" required
                                onChange={formik.handleChange} value={formik.values.name}
                                className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="machine_type_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('MachineList.Column.MachineTypeName')}</label>
                            <select required
                            name='machine_type_id'
                            onChange={formik.handleChange} value={formik.values.machine_type_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('MachineAdd.SelectMachineType')}</option>
                            {state.machine_types.map((machine_type) => (
                                <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                            ))}
                            </select>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Description')}</label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>  
                        {(maintenance_template!=null && type=="add") && <div className="flex align-items-center mt-2">
                            <Checkbox name="copy_records" value="copy_records" onChange={(e) => formik.setFieldValue("copy_records",e.checked)} checked={formik.values.copy_records} />
                            <label htmlFor="copy_records" className="ml-2">{t('Ui.R67.Kopirovat_aj_ukony_sablony')}</label>
                        </div>}   
                        <button className='hidden' type='submit' ref={submitRef}></button>
            </div>
            </div>
            </div> 
             </form>
            </div>
            </> 
            );
} 
